<section class="menubutton"
         id="menubutton"
         (click)="closeMenu($event)"
         [@showMenu]="show ? 'expanded' : 'collapsed'">

  <div fxLayout="column"
       id="menu-user"
       class="menu-user default-border">

    <div class="w-100 menubutton__header"
         fxLayout="row"
         fxLayoutAlign="space-between center">

      <span class="menubutton__header-name pl-2">
        PAINEL DO USUÁRIO
      </span>

      <button mat-icon-button
              (click)="close()"
              color="white">
        <mat-icon>close</mat-icon>
      </button>

    </div>

    <div class="p-2">
      Olá <span class="menubutton__user">{{user?.name ? user?.name : 'Nome Usuário'}}</span>
    </div>

    <div class="px-2"
         fxLayout="row layout-wrap">
      <span class="mr-2">
        USUÁRIO:
      </span>
      <span class="menubutton__text">
        {{user?.userName ? user.userName : '00000000000' | cpfPipe}}
      </span>
    </div>
    <div class="p-2"
         fxLayout="row layout-wrap"
         *ngIf="user && user?.organizationNome">
      <span class="mr-2">
        CFC:
      </span>
      <span class="menubutton__text">
        {{user?.organizationNome}}
      </span>
    </div>

    <mat-divider class="w-100"> </mat-divider>

    <div fxLayout="column">
      <ng-template *ngFor="let item of menuItems"
                   [permission]="item.hash">
        <div fxLayout="row"
             fxLayoutAlign="start center"
             [routerLink]="[item.route]"
             (click)="clickItem(item.id)"
             routerLinkActive="router-link-active"
             class="pl-2 menubutton__line">
          <mat-icon class="mr-2">{{item.icon}}</mat-icon>
          <span>{{item.description}}</span>
        </div>
      </ng-template>
    </div>
  </div>
</section>
